import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTradingViewLine: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="trading-view-line"><path d="M1.75 16.0833L6.875 10.25L14.05 17.25L22.25 6.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconTradingViewLine;
